import { createContext, useContext, useEffect, useState } from "react";
import { I18n } from 'i18n-js';
import en from "./en";
import sv from "./sv";

export const LocaleContext = createContext({
  locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : navigator.language.substring(0, 2) == 'sv' ? 'sv' : 'en',
  //currentLocale: I18n.currentLocale(),
  setLocale: () => { },
});

const translations = {
  "sv": sv,
  "en": en,
};

export const LocaleProvider = (props) => {
  const [locale, setLocale] = useState(localStorage.getItem('locale') ? localStorage.getItem('locale') : navigator.language.substring(0, 2) == 'sv' ? 'sv' : 'en');

  const translate = (name, useLocale) => {
    useLocale = useLocale ? useLocale : locale ? locale : I18n.defaultLocale;
    let translation = translations[useLocale] || translations[I18n.defaultLocale];
    let string = getProperty(name, translation);
    return string || name;
  }

  const changeLocale = (lang) => {
    setLocale(lang.substring(0, 2));
    localStorage.setItem('locale', lang.substring(0, 2)); //Spara locale

    //Uppdatera lang-attribut i html-taggen
    document.documentElement.lang = lang.substring(0, 2);
  }

  const defaultLocale = {
    locale,
    setLocale:changeLocale,
    translate,
  };

  function getProperty(propertyName, object, fallback) {
    var parts = [propertyName], length = parts.length, i, property = object || this;
    for (i = 0; i < length; i++) {
      property = property[parts[i]];
    }
    return property;
  }



  return (
    <LocaleContext.Provider value={defaultLocale}>
      {props.children}
    </LocaleContext.Provider>
  );
};

export const useLocale = () => useContext(LocaleContext);